import { Zap, MapPin, Plane, Globe } from "lucide-react";

export default function AnnouncementBar() {
  const items = [
    { Icon: Plane, t: "Worldwide Shipping · USA · UK · Canada · Australia · UAE" },
    { Icon: Zap, t: "Delhi NCR · 24-hour Urgent Orders" },
    { Icon: Globe, t: "Custom Wedding Invitations · Indian & Destination Weddings" },
    { Icon: MapPin, t: "DTDC · Blue Dart · DHL Express Partners" },
    { Icon: Zap, t: "NRI Weddings · Free WhatsApp Consultation" },
  ];

  return (
    <div
      data-testid="announcement-bar"
      className="bg-[#F0C4BC] text-[#0E0709] border-b border-[#E8B4AC] overflow-hidden relative z-50"
    >
      <div className="marquee-track flex gap-12 whitespace-nowrap py-2.5">
        {[...Array(2)].map((_, k) => (
          <div key={k} className="flex gap-12 items-center">
            {items.map((it, i) => (
              <span key={`${k}-${i}`} className="flex items-center gap-3 text-[11px] tracking-[0.22em] uppercase font-medium">
                <it.Icon className="w-3.5 h-3.5" strokeWidth={2.2} />
                {it.t}
                <span className="text-[#0E0709]/40">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
